import { StarRating } from '@/components/resultList/components/StarRating';
import type { LmsFilters } from '@/interfaces/lms';
import { updateListFilter } from '@/lib/utils/lmsQueryParams';
import { SimpleCheckboxFilter } from './checkbox/SimpleCheckboxFilter';

type LmsRatingFilterProps = {
    filters: LmsFilters;
    updateFilters: (key: string, value: string[]) => void;
};

export const LmsRatingFilter = ({ filters, updateFilters }: LmsRatingFilterProps) => {
    const options = [
        { value: '5', text: <StarRating id="starRating5" rating={5} /> },
        { value: '4', text: <StarRating id="starRating4" rating={4} /> },
        { value: '3', text: <StarRating id="starRating3" rating={3} /> },
        { value: '2', text: <StarRating id="starRating2" rating={2} /> },
        { value: '1', text: <StarRating id="starRating1" rating={1} /> },
    ];

    const onChange = (value: string) => {
        updateFilters('stjerner', updateListFilter(value, filters.stjerner));
    };

    return <SimpleCheckboxFilter id="rating" options={options} checked={filters.stjerner} onChange={onChange} />;
};
